function warn(s) {
  console.warn('[react-ga]', s);
}

module.exports = warn;



//////////////////
// WEBPACK FOOTER
// ../node_modules/react-ga/src/utils/console/warn.js
// module id = 547
// module chunks = 0